<template>
   <div class="gz-file-input__container">
        <Label 
            v-if="label"
            :label="label"  
            :required="required"
            :note="note"
        />
        
        <div v-if="template" class="gz-file-input__template">
            <span class="icon-file-text"></span>
            <a :href="template" target="blank">Скачать шаблон</a>
        </div>
        
        <div
            ref="filePreview" 
            :class="{'gz-file-input_preview': !sizeSmall, 'gz-file-input_preview_small': sizeSmall}">
            <!-- javascript init() -->
        </div>
        <!-- {{importedDataComputed}} -->
        <input
            type="file"          
            ref="fileInput"
            :title="disabled ? 'загрузка файлов недоступна' : 'загрузите файл'"
            :class="{
                'gz-file-input gz-file-input_add': !sizeSmall, 
                'gz-file-input_small gz-file-input_add_small': sizeSmall, 
                'gz-file-input_disabled': disabled
            }"
            :accept="accept"
            @change="init(), $emit('change')"
            :multiple="multiple"
            :disabled="disabled">
        
        <!-- Validation -->
        <ValidationMark
            :valid="valid" 
            :validationMessage="validationMessage" 
            class="gz-input-container__validation_file"
        />

   </div> 
</template>

<script>
import Label from './Label'
import ValidationMark from '@/components/ui/forms/BaseValidationMark'

export default {
    name: 'FileInput',
    
    props: {
        label: String,
        note: String,
        template: String, //Ссылка на шаблон для скачивания
        required: {
            type: Boolean,
            default: false
        },
        accept: {
            type: String
        },
        multiple: {
            type: Boolean,
            default: true
        },
        maxfiles: String,
        importedData: {
            type: Array,
            default: () => ([
            ])
        },
        sizeSmall: {
            //Уменьшеный размер блока
            type: Boolean,
            default: false
        },
        valid: {
            type: Boolean,
            default: true
        },
        validationMessage: {
            type: String
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    components: {
        Label,
        ValidationMark
    },
    data() {
        return {
            loadedFiles: []
        }
    },
    computed: {
        importedDataComputed() {
            return this.importedData
        }
    },
    methods: {
        init() {
            this.getFiles()
            this.previewFiles()
        },
        getFiles() {
            Object.values(this.$refs.fileInput.files).forEach((item, index) => {
                if (this.multiple) {
                    this.loadedFiles.push(item)
                } else {
                    this.loadedFiles[index] = item
                }
            })   

            console.log(this.loadedFiles)
            
            this.$emit('loadedFiles', this.loadedFiles)
        },
        previewFiles() {
                let files = this.$refs.fileInput.files            

                const targetNode = this.$refs.filePreview
                // targetNode.innerHTML = ''
                
                // const reader = new FileReader()
                
                for (let i = 0; i < files.length; i++) {
                ( function(file, that) {
                    const reader = new FileReader()
                    
                    reader.onload = () => {
                        // let imagePreview = reader.result

                        let container = document.createElement("div")
                        container.classList.add('gz-file-input_preview__item')

                        let fileNameContainer = document.createElement("div")
                        fileNameContainer.classList.add('gz-file-input_preview__container')

                        let fileName = document.createElement("div")
                        fileName.classList.add('gz-file-input_preview__name')
                        fileName.innerHTML = files[i].name
                        /** 
                            * Помечаю контейнер дата атрибутом, чтобы связать 
                            * его с записью в массиве с файлами. Для возможности 
                            * их удаления в дальнейшем
                        */
                        container.setAttribute('data-index', i)
                        
                        let fileIcon = document.createElement("span")
                        fileIcon.classList.add('icon-attachment', 'gz-file-input_preview__icon')

                        let remove = document.createElement("span")
                        remove.classList.add('icon-cross', 'gz-file-input_preview_remove')

                        remove.addEventListener('click', () => { 
                            //Удаляю контейнер с изображением
                            event.target.parentNode.parentNode.removeChild(event.target.parentNode) 
                            
                            //Удаляю соответствующий элемент из массива с файлами
                            if (files.length > 0) {
                                that.loadedFiles.splice(+event.target.parentNode.dataset.index, 1)
                            }

                            if (files === 0) {
                                that.loadedFiles = []
                            }

                            //Присваиваю оставшимся контейнерам с изображениями новые значения data-index с учетом удаленного
                            const imgContainers = document.querySelectorAll('.gz-file-input_preview__item')
                            imgContainers.forEach((item, index) => { item.setAttribute('data-index', index) })
                        })

                        if (!that.multiple) targetNode.innerHTML = ''

                        container.appendChild(fileNameContainer)
                        fileNameContainer.appendChild(fileIcon)
                        fileNameContainer.appendChild(fileName)
                        container.appendChild(remove)
                        targetNode.appendChild(container)
                    }

                    reader.readAsDataURL( file )
                })(files[i], this)
                }
            },
        previewSavedFiles(item, i) {
            const targetNode = this.$refs.filePreview

            let container = document.createElement("div")
            container.classList.add('gz-file-input_preview__item')

            let fileNameContainer = document.createElement("div")
            fileNameContainer.classList.add('gz-file-input_preview__container')

            let fileName = document.createElement("div")
            fileName.classList.add('gz-file-input_preview__name')
            fileName.innerHTML = item.id ? item.id : `док. ${i+1}`

            let fileLink = document.createElement("span")
            fileLink.classList.add('icon-download', 'gz-file-input_preview__link-icon')
            fileLink.addEventListener('click', () => {
                window.open(item.link, '_blank')
            })
            /** 
                * Помечаю контейнер дата атрибутом, чтобы связать 
                * его с записью в массиве с файлами. Для возможности 
                * их удаления в дальнейшем
            */
            container.setAttribute('data-index', i)
            
            let fileIcon = document.createElement("span")
            fileIcon.classList.add('icon-attachment', 'gz-file-input_preview__icon')

            let remove = document.createElement("span")
            remove.classList.add('icon-cross', 'gz-file-input_preview_remove')

            remove.addEventListener('click', () => { 
                //Удаляю контейнер с изображением
                event.target.parentNode.parentNode.removeChild(event.target.parentNode) 
                
                //Удаляю соответствующий элемент из массива с файлами
                if (this.loadedFiles > 0) {
                    this.loadedFiles.splice(+event.target.parentNode.dataset.index, 1)
                }

                if (this.loadedFiles === 0) {
                    this.loadedFiles = []
                }

                //Присваиваю оставшимся контейнерам с изображениями новые значения data-index с учетом удаленного
                const imgContainers = document.querySelectorAll('.gz-file-input_preview__item')
                imgContainers.forEach((item, index) => { item.setAttribute('data-index', index) })
            })

            container.appendChild(fileNameContainer)
            fileNameContainer.appendChild(fileIcon)
            fileNameContainer.appendChild(fileName)
            fileNameContainer.appendChild(fileLink)
            container.appendChild(remove)
            targetNode.appendChild(container)            
        }        
    },
    watch: {
        importedDataComputed: function(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.importedDataComputed.forEach((item, index) => {
                    this.previewSavedFiles(item, index)
                })
            }
        },
        deep: true
    }
}
</script>